import { Link } from "wouter";
import { cn } from "@/lib/utils";
import { SOURCE_TYPES, SOURCE_SLUGS, type SourceType } from "@shared/websiteSubmissions";

export type WebsiteTab = SourceType | "qr";

const LABEL: Record<WebsiteTab, string> = {
  valuation: "Valuations",
  subscriber: "Subscribers",
  buyer: "Buyers",
  qr: "QR codes",
};

const href = (t: WebsiteTab) => (t === "qr" ? "/website/qr" : `/website/${SOURCE_SLUGS[t]}`);

/** The Website page's tab strip, shared by the submissions view and the QR codes view. */
export function WebsiteTabs({ active, counts }: { active: WebsiteTab; counts: Partial<Record<WebsiteTab, number>> }) {
  const tabs: WebsiteTab[] = [...SOURCE_TYPES, "qr"];
  return (
    <nav className="flex items-center gap-1">
      {tabs.map((t) => {
        const isActive = t === active;
        const n = counts[t];
        return (
          <Link
            key={t}
            href={href(t)}
            className={cn(
              "flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium transition-colors",
              isActive ? "bg-accent text-accent-foreground" : "text-muted-foreground hover:bg-muted hover:text-foreground",
            )}
          >
            {LABEL[t]}
            {n !== undefined && (
              <span className={cn("rounded px-1.5 text-xs tabular-nums", isActive ? "bg-white/15" : "bg-muted-foreground/12")}>
                {n}
              </span>
            )}
          </Link>
        );
      })}
    </nav>
  );
}
